import { Component, HostBinding } from "@angular/core";

@Component({
	selector: "layout-footer",
	template: "<ng-content></ng-content>",
})
export class LayoutFooterComponent {
	@HostBinding('style.flex') flex = '1';
}